module.exports = __webpack_public_path__ + "img/search.068f9c6d.png";